var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaderActive)?_c('div',{staticClass:"loader--container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/img/loader-1.gif"}})])
}]

export { render, staticRenderFns }